<div class="component-loader" *ngIf="status">
    <span class="zf-btn-loader"></span>
</div>
